"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: ", " 0 ", " 0;\n  background: ", ";\n  border-radius: 10px;\n  padding: ", ";\n  overflow: hidden;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageSection = void 0;

var react_1 = __importDefault(require("react"));

var styled_1 = require("../styled");

var theme_1 = require("../theme");

var typography_1 = require("../typography");

var useColorScheme_1 = require("./useColorScheme");

function PageSection(_a) {
  var title = _a.title,
      padded = _a.padded,
      rest = __rest(_a, ["title", "padded"]);

  return react_1.default.createElement(react_1.default.Fragment, null, title ? react_1.default.createElement(_PageSectionHeader, {
    color: '@text-color-secondary',
    children: title
  }) : null, react_1.default.createElement(_PageSection, Object.assign({}, rest, {
    padded: padded,
    hasTitle: !!title,
    isDark: (0, useColorScheme_1.useColorScheme)() === 'dark'
  })));
}

exports.PageSection = PageSection;

var _PageSectionHeader = (0, styled_1.styled)(typography_1.BodySmall)(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-s');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-s');
});

var _PageSection = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return props.hasTitle ? (0, theme_1.getSize)(props.theme, '@size-xs') : 0;
}, function (props) {
  return (0, theme_1.getSize)(props.theme, '@size-s');
}, function (props) {
  return (0, theme_1.getColor)(props.theme, props.isDark ? '@gray-1' : '@component-background');
}, function (props) {
  return props.padded ? (0, theme_1.getSize)(props.theme, '@size-s') : 0;
});